import { styled } from 'twin.macro';

import Subtitle from './Subtitle';

const SuccessText = styled(Subtitle)`
  color: var(--color-darkBlue);
`;

export default SuccessText;